import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";
import { responsive, responsiveCard } from "@huub-web/ui/utils/responsive";

export const timesStyle = style({
  lineHeight: 0.6,
  fontWeight: 400,
  whiteSpace: "nowrap",
  wordBreak: "break-word",
  ...responsive({
    base: {
      fontSize: rem(36),
    },
    s: {
      fontSize: rem(42),
    },
  }),
});

export const tagLineStyle = style({
  maxWidth: rem(200),
  lineHeight: 1.15,
});

export const innerStyle = style({});

export const contentClassName = style({
  flexDirection: "column",
  justifyContent: "flex-start",
  ...responsiveCard({
    400: {
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
    },
  }),
});
